import React from "react";
import {
  Button,
  Grid,
  CardContent,
  CardHeader,
  Card,
  Divider,
} from "@material-ui/core";
import { CreateInvoicesTable } from "./CreateInvoicesTable";
import { usePageStyles } from "../../pageStyles";
import { PageComponent } from "../../../core/navigation/types";
import { PageTitle } from "../../components/common/PageTitle";
import { CreateInvoicesFilter } from "./CreateInvoicesFilter";
import { LocalizationContext } from "../../../core/localization/Localization";
import { CreateButton } from "./CreateButton";

const CreateInvoicesPage: PageComponent = ({ userAccessRights }) => {
  const pageStyles = usePageStyles();

  return (
    <>
      <Grid container className={pageStyles.root}>
        <Grid item xs={12} className={pageStyles.gridItem}>
          <Card>
            <CardHeader
              title={<PageTitle title="createInvoiceTitle" />}
              action={<CreateInvoicesActions />}
            />
            <Divider />
            <CardContent>
              <CreateInvoicesTable userAccessRights={userAccessRights} />
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </>
  );
};

export const CreateInvoicesActions: React.FunctionComponent = () => (
  <Grid container>
    <Grid item>
      <CreateButton />
    </Grid>
    <Grid item>
      <CreateInvoicesFilter />
    </Grid>
  </Grid>
);

export default CreateInvoicesPage;
